import { render } from "./Dot.vue?vue&type=template&id=eba65b9a&scoped=true&ts=true"
import script from "./Dot.vue?vue&type=script&lang=ts"
export * from "./Dot.vue?vue&type=script&lang=ts"

import "./Dot.vue?vue&type=style&index=0&id=eba65b9a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eba65b9a"]])

export default __exports__